import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TabItem } from '../../models/formly-custom';

@Component({
  selector: 'app-tab-group',
  imports: [],
  templateUrl: './tab-group.component.html',
  styleUrl: './tab-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabGroupComponent {
  activeTabId: number = 0;

  @Input() tabList: TabItem[] = [];

  @Input() set activeItem(item: any) {
    this.activeTabId = item?.id; //unique tab no
  }

  @Output() tabChanged: EventEmitter<any> = new EventEmitter();

  constructor() {}

  setActiveTab(tab: any) {
    if (tab.id != this.activeTabId) {
      this.activeTabId = tab.id;
      this.tabChanged.emit(tab);
    }
  }
}
